import { useEqualMemo } from '@gogame/hooks-ts';

import { parseChildren } from '../declarationComponentsAndParser';

export const useParseChildrenMemo = ({
  children,
  stacked,
  percentage,
  compareMode,
  type,
  label,
}) => {
  const {
    series: newSeries,
    metrics: newMetrics,
    unknown,
    dateAxis: newDateAxis,
    metricsTooltip: newMetricsTooltip,
    noSeriesPlaceholder,
    annotationsMetric: newAnnotationsMetric,
  } = parseChildren(children, {
    stacked,
    percentage,
    compareMode,
    type,
    label,
  });
  const series = useEqualMemo(newSeries);
  const metricsTooltip = useEqualMemo(newMetricsTooltip);
  const dateAxis = useEqualMemo(newDateAxis);
  const metrics = useEqualMemo(newMetrics);
  const annotationsMetric = useEqualMemo(newAnnotationsMetric);

  return {
    series,
    metricsTooltip,
    dateAxis,
    metrics,
    unknown,
    noSeriesPlaceholder,
    annotationsMetric,
  };
};
